import { Drawer as AntdDrawer } from 'antd'
import React from 'react'
import styled from 'styled-components'
import Footer from './partials/Footer'

const StyledDrawer = styled(AntdDrawer)`
  .ant-drawer-body {
    padding: ${props => (props.padding ? props.padding : '30px')};
    overflow: ${props => (props.overflowBody ? props.overflowBody : 'auto')};
    height: ${props => (props.isBanner ? '100%' : 'auto')};
  }

  .ant-drawer-wrapper-body {
    height: ${props => (props.isBanner ? '100%' : '92%')};
    overflow: auto;
  }
  .ant-drawer-content-wrapper {
    z-index: ${props => (props.zIndex ? props.zIndex + 1 : '1001')};
  }
  .ant-drawer-header-title {
    flex-direction: ${props =>
      props.closeIconPosition === 'right' ? 'row-reverse' : 'row'};
  }
  .ant-drawer-header {
    display: ${props => (props.isBanner ? 'none' : 'flex')};
  }
`

const Drawer = ({
  width = '40%',
  title,
  placement,
  closable = false,
  onClose,
  visible,
  content,
  footer,
  footerStyles,
  closeIconPosition = 'right',
  padding,
  isBanner = false,
  zIndex,
  ...rest
}) => {
  return (
    <StyledDrawer
      {...rest}
      width={width}
      title={title}
      placement={placement}
      closable={closable}
      onClose={onClose}
      visible={visible}
      key={placement}
      closeIconPosition={closeIconPosition}
      padding={padding}
      isBanner={isBanner}
      zIndex={zIndex}
    >
      {content}
      {footer && <Footer footerStyles={footerStyles}>{footer}</Footer>}
    </StyledDrawer>
  )
}
export default Drawer
